import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { AdvancedReportConfigurationValidation } from 'uplisting-frontend/validations';

export default class AdvancedReportConfigurationRepositoryService extends BaseRepositoryService<
  ModelRegistry['advanced-report-configuration']
> {
  recordName = 'advanced-report-configuration';
  implementMethods = [
    'findAll',
    'peekRecord',
    'peekAll',
    'buildChangeset',
    'createRecord',
  ];

  validation = AdvancedReportConfigurationValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/advanced-report-configuration': AdvancedReportConfigurationRepositoryService;
  }
}
